



























































































































import {
  defineComponent, reactive, computed, ref,
} from '@vue/composition-api';
import { useMutation, useResult, useQuery } from '@vue/apollo-composable';
import { useRouter, useFormat } from 'vivat';
import { ToggleButton } from 'vue-js-toggle-button';

import user from '@/table/setting/user';

import getUsers from '@/gql/usersSetting/getUsers.gql';
import updateUser from '@/gql/usersSetting/updateUser.gql';
import deleteUser from '@/gql/usersSetting/deleteUser.gql';

import createRole from '@/gql/usersSetting/createRole.gql';
import getRoles from '@/gql/usersSetting/getRoles.gql';
import deleteRole from '@/gql/usersSetting/deleteRole.gql';

import CommonFormWithRoleEditor from '@/components/CommonFormWithRoleEditor.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

import useAuth from '@/useAuth';

const List = defineComponent({
  setup() {
    const { route, router } = useRouter();

    const { result: getRolesQuery } = useQuery(getRoles);
    const rolesResult = useResult(getRolesQuery, [], (data) => data.roles);

    const formCreate = reactive({
      name: '',
    });
    const createRoleMutation = useMutation(createRole, () => ({
      variables: {
        input: formCreate,
      },
      refetchQueries: ['getRoles'],
    }));
    createRoleMutation.onDone((result: any) => {
      router.push({ name: 'UserList', params: { roleId: result.data.createRole.id } });
    });

    const deleteRoleMutation = useMutation(deleteRole, () => ({
      refetchQueries: ['getRoles'],
    }));
    function deleteRoleAction(roleId: string) {
      deleteRoleMutation.mutate({
        id: roleId,
      });
    }
    deleteRoleMutation.onDone(() => {
      router.push({ name: 'User' });
    });

    // Search filter
    const search = reactive({
      text: '',
    });

    // =================== DELETE FUNCTION ======================
    // Delete dialog
    const deleteUserModal = ref(null);
    // Delete Mutation variables
    const deleteUserVariable = reactive({ id: -1 });
    // ==== Delete Mutation ==== //
    const deleteMutation = useMutation(
      deleteUser,
      () => ({
        variables: {
          id: deleteUserVariable.id,
        },
        refetchQueries: ['getUsers', 'getRoles', 'getMyInfo'],
      }),
    );
    function openDeleteUserModal(item: any) {
      (deleteUserModal.value as any).compose({
        id: parseInt(item.id, 10),
        action: 'ลบ',
        entity: 'ผู้ใช้งาน',
        body: `เป็นการลบ<br>${item.name}<br>จากระบบโดยถาวร<br>ไม่สามารถย้อนคืนได้`,
      });
    }
    deleteMutation.onDone(() => {
      deleteUserVariable.id = -1;
    });
    // ==== Trigger Delete User mutation
    function deleteUserAction(id: any) {
      deleteUserVariable.id = id;
      deleteMutation.mutate();
    }

    // Active Deactive Mutation
    const toggleVariables = reactive({
      id: '',
      status: true,
    });
    const updateUserMutation = useMutation(
      updateUser,
      () => ({
        variables: {
          input: {
            id: toggleVariables.id,
            active: toggleVariables.status,
          },
        },
        refetchQueries: ['getUsers', 'getRoles'],
      }),
    );

    function setActiveStatus(id: any, status: boolean) {
      toggleVariables.id = id;
      toggleVariables.status = status;
      updateUserMutation.mutate();
    }

    // ==== Use to search User ==== //
    const usersListVariables = computed(() => {
      const vars: {[key: string]: any} = {
        searchName: undefined,
        filterRoleId: route.value.params.roleId,
      };
      if (search.text) {
        vars.searchName = `%${search.text}%`;
      }
      return vars;
    });

    // ==== Use Format ==== //
    function useDateTimeFormat(date: any) {
      if (!date) return '';
      return `${useFormat.date(date).displayShortThaiDate()} เวลา ${date.substring(11, 16)}`;
    }

    const { me, hasPermission } = useAuth();

    const getRoleDisplayFromRoute = computed(() => {
      if (rolesResult?.value) return rolesResult.value.find((elm: any) => elm.id === route.value.params.roleId);
      return '';
    });

    const pendingToActionUser = reactive({ id: -1 });
    const pendingChangeRole = ref(-1);
    // ==== Update user role ==== //
    const changeUserRoleMutation = useMutation(updateUser, () => ({
      variables: {
        input: {
          id: pendingToActionUser.id,
          roles: {
            sync: [pendingChangeRole.value],
          },
        },
      },
      refetchQueries: ['getUsers'],
    }));
    function updateUserRoleAction(userId: number, roleId: number) {
      pendingToActionUser.id = userId;
      pendingChangeRole.value = roleId;
      changeUserRoleMutation.mutate();
    }
    changeUserRoleMutation.onDone(() => {
      pendingToActionUser.id = -1;
      pendingChangeRole.value = -1;
    });

    return {
      me,
      hasPermission,

      rolesResult,
      createRoleMutation,
      deleteRoleAction,
      formCreate,

      userTableOption: user,
      getUsersQuery: getUsers,
      getUsersResult: (data: any) => data.users,
      search,
      // Delete User funtion
      deleteUserModal,
      openDeleteUserModal,
      // setDeleteUserVariable,
      deleteUserAction,
      // User list gql
      usersListVariables,
      deleteMutation,
      setActiveStatus,
      useDateTimeFormat,

      getRoleDisplayFromRoute,

      // update user role
      updateUserRoleAction,
    };
  },
  components: {
    ToggleButton,
    CommonModalWithPreset,
    CommonFormWithRoleEditor,
  },
  props: {
    role: {},
  },
});

export default List;
